import React from "react";

import { List, TextField, FunctionField, FilterButton } from "jazasoft";

import Datagrid from "../components/Datagrid";
import TooltipTextField from "../components/TooltipTextField";

import { OState } from "../utils/types";
import SettingKeys from "../utils/SettingKeys";
import useQuery from "../hooks/useQuery";
import filters from "./OrderFilter";
import { isEmpty } from "../utils/helpers";
import { useSetting, useUnit } from "../hooks";

const OrderStateValue = Object.keys(OState)
  .map(key => OState[key])
  .reduce((acc, e) => ({ ...acc, [e.state]: e.stateValue }), {});

const renderState = record => {
  const stateList = record?.states?.split(",");
  const state = stateList
    ?.map(state => ({ state, value: OrderStateValue[state] }))
    .sort((a, b) => a.value - b.value)[0]?.state;
  return state + `${stateList?.length > 1 ? "*" : ""}`;
};

const parse = ({ unitId, customerId, seasonId, productName, state }) => ({
  allocUnitIds: unitId === "all" ? unitId : !isEmpty(unitId) ? `*${unitId}*` : null,
  "customer.id": customerId,
  "season.id": seasonId,
  products: isEmpty(productName) ? null : `*${productName}*`,
  states: state,
});

const OrderHome = props => {
  const { filterDefaultValues = {}, withState = true, rowClick = "view", i18nKey, ...restProps } = props;
  const { data: productList = [] } = useQuery({ url: "products", params: { size: 1000, sort: "name,asc" } });
  const orderFields = useSetting(SettingKeys.ENTITY_FIELDS, "orders");

  const { allUnitList } = useUnit();
  const unitChoices = [{ id: "all", name: "All Units" }, ...allUnitList.map(({ unitId, name }) => ({ id: unitId, name }))];

  return (
    <List
      parse={parse}
      searchKeys={["poRef", "customerPoRef", "styles"]}
      filters={filters(withState, productList, unitChoices)} // withState: order state filter
      filterDefaultValues={filterDefaultValues}
      actions={({ resource }) => (
        <div>
          <FilterButton showLabel={false} resource={resource} />
        </div>
      )}
      i18nKey="orders"
      title={`resources.${i18nKey}.name`}
      {...restProps}>
      <Datagrid rowClick={rowClick}>
        {orderFields.includes("poRef") && <TooltipTextField source="poRef" />}
        {orderFields.includes("customer") && <TextField source="customer.name" />}
        {orderFields.includes("products") && <TooltipTextField source="products" />}
        {orderFields.includes("styles") && <TooltipTextField source="styles" />}
        {orderFields.includes("season") && <TextField source="season.name" />}
        {orderFields.includes("orderQty") && <TextField source="orderQty" />}
        {orderFields.includes("lines") && <TooltipTextField source="lines" />}
        {orderFields.includes("status") && <FunctionField source="status" render={renderState} />}
      </Datagrid>
    </List>
  );
};

export default OrderHome;
